import { deleteField } from 'firebase/firestore';
import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

import { taskApi } from 'api';
import { MyRef, myStorage } from 'Common/Firebase';

async function addVideo(file: File, currentICLId: string, taskId: string) {
  const newId = uuidv4();
  const fileNameWithId = `id-${newId}-${file.name}`; // each file name in storage must have a unique name otherwise it is not possible to add two different files with the same name

  const storageRef = MyRef(myStorage, 'Video/' + fileNameWithId);

  const snapshot = await uploadBytes(storageRef, file);
  const videoUrl = await getDownloadURL(snapshot.ref);
  await taskApi.updateTask(currentICLId, { id: taskId, videoUrl });

  return videoUrl;
}

async function removeVideo(videoUrl: string, currentICLId: string, taskId: string) {
  const fileRef = ref(myStorage, videoUrl);

  await deleteObject(fileRef);
  await taskApi.updateTask(currentICLId, { id: taskId, videoUrl: deleteField() });
}

export const videoApi = {
  addVideo,
  removeVideo,
};
